import React from 'react';
import Icon from '../../../components/AppIcon';

const ConnectionStatus = ({ isWalletConnected, walletAddress, networkStatus }) => {
  const formatAddress = (address) => {
    if (!address) return '';
    return `${address?.slice(0, 8)}...${address?.slice(-6)}`;
  };

  const getNetworkStatusColor = (status) => {
    switch (status) {
      case 'connected':
        return 'text-success';
      case 'connecting':
        return 'text-warning';
      case 'disconnected':
        return 'text-destructive';
      default:
        return 'text-muted-foreground';
    }
  };

  const getNetworkStatusIcon = (status) => {
    switch (status) {
      case 'connected':
        return 'CheckCircle';
      case 'connecting':
        return 'Loader2';
      case 'disconnected':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto mb-6">
      <div className="bg-card border border-border rounded-lg p-4">
        <h3 className="text-sm font-medium text-foreground mb-3 flex items-center space-x-2">
          <Icon name="Wifi" size={16} />
          <span>Connection Status</span>
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Wallet Status */}
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-md">
            <div className="flex items-center space-x-2">
              <Icon name="Wallet" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">Wallet</span>
            </div>
            <div className="flex items-center space-x-2">
              {isWalletConnected ? (
                <>
                  <Icon name="CheckCircle" size={14} className="text-success" />
                  <span className="text-xs font-mono text-foreground">
                    {formatAddress(walletAddress)}
                  </span>
                </>
              ) : (
                <>
                  <Icon name="XCircle" size={14} className="text-destructive" />
                  <span className="text-xs text-muted-foreground">Not Connected</span>
                </>
              )}
            </div>
          </div>

          {/* Network Status */}
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-md">
            <div className="flex items-center space-x-2">
              <Icon name="Zap" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">Network</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon 
                name={getNetworkStatusIcon(networkStatus)} 
                size={14} 
                className={`${getNetworkStatusColor(networkStatus)} ${
                  networkStatus === 'connecting' ? 'animate-spin' : ''
                }`} 
              />
              <span className="text-xs text-foreground">
                {networkStatus === 'connected' ? 'Polygon' : 
                 networkStatus === 'connecting'? 'Connecting...' : 'Disconnected'}
              </span>
            </div>
          </div>
        </div>

        {/* Connection Warning */}
        {!isWalletConnected && (
          <div className="mt-4 p-3 bg-warning/5 border border-warning/20 rounded-md">
            <div className="flex items-start space-x-2">
              <Icon name="AlertTriangle" size={14} className="text-warning mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-xs text-warning font-medium">Wallet Connection Required</p>
                <p className="text-xs text-warning/80 mt-1">
                  Please connect your wallet to proceed with notarization
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConnectionStatus;